<template>
  <div>
    <codemirror
      :value="sourceAdapterMessage.body"
      :options="options"
      class="test"
    ></codemirror>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";

export default {
  name: "DataTransmission",
  components: {
    codemirror
  },
  data: () => ({
    options: {
      lineNumbers: true,
      foldGutter: true,
      gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
      readOnly: true,
      mode: "application/json"
    }
  }),
  computed: {
    sourceAdapterMessage: {
      get() {
        let sourceAdapterMessage = this.$store.getters[
          "projectMeteringStore/sourceAdapterMessageStore/getItem"
        ];
        let data = sourceAdapterMessage && sourceAdapterMessage.body;
        if (data) {
          try {
            if (sourceAdapterMessage.data_type === "json") {
              data = JSON.stringify(JSON.parse(data), null, 4);
            }
          } catch (e) {
            sourceAdapterMessage.data_type = "";
            this.$store.dispatch("notificationStore/createNotification", {
              text: this.$t("source-adapter-messages.error-parsing-data"),
              type: "warning",
              value: true
            });
          }
          sourceAdapterMessage.value = data;
        }
        return sourceAdapterMessage;
      }
    },
    value: {
      get() {
        return this.sourceAdapterMessage && this.sourceAdapterMessage.data;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.test {
  height: calc(100vh - 250px);
  &::v-deep .CodeMirror {
    height: 100%;
  }
}
</style>
